module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/radio_button_checked_VA.a146f0c4.svg";